import {FilterContext} from 'plugins/modules/filter/context/new';
import React, {FC, ReactNode, useMemo} from 'react';
import {IGetCatalogFiltersProps, useGetFiltersQuery} from 'modules/products/services';
import {useGetFiltersQueryData} from 'plugins/modules/filter/hooks/useGetFiltersQueryData';
import {useGetFiltersCatalogProviderValue} from 'plugins/modules/filter/hooks/useGetFiltersProviderValue';
import {getCatalogSection} from 'modules/products/helpers';
import {useRouter} from 'next/router';

interface IProps {
    children: ReactNode;
}

export const FilterProvider: FC<IProps> = ({children}) => {
    const router = useRouter();

    const query = useMemo(() => {
        const section = getCatalogSection(router.query.slug);

        return {
            section,
        };
    }, [router]);

    const filtersQueryData = useGetFiltersQueryData(query);

    const {data, refetch, isLoading, isFetching} = useGetFiltersQuery(filtersQueryData as IGetCatalogFiltersProps);

    const value = useGetFiltersCatalogProviderValue({data, refetch, isLoading, isFetching});

    return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};
